import { render, staticRenderFns } from "./cangchu.vue?vue&type=template&id=19388df6&scoped=true&"
import script from "./cangchu.vue?vue&type=script&lang=js&"
export * from "./cangchu.vue?vue&type=script&lang=js&"
import style0 from "./cangchu.vue?vue&type=style&index=0&id=19388df6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19388df6",
  null
  
)

export default component.exports